import _get from 'lodash/get';
import { AttachmentValue } from '@lib/components/FileUploaderUppy/FileUploaderUppy';
import { getFormatFromMimeType } from '@lib/utils/files';

export type AttachmentMeta = {
  mimeType: string;
  size: number;
  filename: string;
  fileFormat: string;
};

const getAttachmentMeta = (
  attachment: AttachmentValue,
  customName?: string | null,
): AttachmentMeta => {
  const mimeType =
    (_get(attachment, 'file.metadata.mimeType', '') as string) ||
    (_get(attachment, 'fileData.data.metadata.mimeType', '') as string);
  const size =
    (_get(attachment, 'file.metadata.size', 0) as number) ||
    (_get(attachment, 'fileData.data.metadata.size', 0) as number);
  const filename =
    customName ||
    (_get(attachment, 'filename', '') as string) ||
    (_get(attachment, 'file.metadata.filename', '') as string) ||
    (_get(attachment, 'fileData.data.metadata.filename', '') as string);

  return {
    mimeType,
    size,
    filename,
    fileFormat: getFormatFromMimeType(mimeType),
  };
};

export default getAttachmentMeta;
